export default "__VITE_ASSET__m5zuUxaR__"